'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'deer';
var width = 512;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = ['M224.3 0l0 40c0 30.9 25.1 56 56 56l88 0 0-32-21.4 0c3.5-7.3 5.4-15.4 5.4-24l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-40-32 0zM377.5 64c24 0 47.1 9.2 64.5 25.8 18-9.3 30.3-28.1 30.3-49.8l0-40-32 0 0 40c0 13.3-10.7 24-24 24l-38.8 0z', 'M320.3 96l-64 16 0 32 56 0-9.6 32-196.3 0C52 176 6.8 217.8 2.7 272 1 293.2-.4 311.2-1.5 326.1l47.9 3.7 1.8-23.3c2.4 3.3 5.2 6.5 8.1 9.5L72.4 332c-18.2 18.2-34 34-47.4 47.4 2.3 6.4 17.9 50.6 46.8 132.6l101.8 0-37.9-107.4c19.8-19.8 33.4-33.4 40.7-40.7l0-23.3 64 27.4 48 0 0 144 96 0 0-208 26.7-80 101.3 0 0-64-68.6-68.6c-17.5-17.5-41.3-27.4-66.2-27.4-3.1 0-6.2 .3-9.2 .8l0 31.2-48 0zm64 48a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;